/**
 * Represents a resource that can be disposed.
 */
export interface Disposable {
  dispose(): void;
}